import React from "react";
import { connect } from "react-redux";
import { Paper, Container, Box, Button } from "@material-ui/core";
import SecurityIcon from "@material-ui/icons/Security";
import theme from "../../theme/theme";
import Navbar from "./CommonNavbar/CommonNavbar";

const withCountryRestriction = (WrappedComponent) => {
  const CountryRestrictedComponent = ({ userDetails, camPermissions, ...props }) => {

    // Check if user is from restricted countries (China, Hong Kong, India for testing)
    const isRestrictedCountry = userDetails &&
      userDetails.hasOwnProperty('custom:country') &&
      (userDetails['custom:country'] === 'China' ||
       userDetails['custom:country'] === 'Hong Kong' );
       // userDetails['custom:country'] === 'India'); // India added for testing

    // Check CAM permissions
    const userRbac = JSON.parse(localStorage.getItem("userRoleBasedAccessControl"));
    const currentCamPermissions = userRbac !== null ? userRbac.data : camPermissions;

    // Only check permissions if they have been loaded (not initial empty state)
    const permissionsLoaded = Object.keys(currentCamPermissions).length > 0 || userRbac !== null;
    const hasNoPermissions = permissionsLoaded &&
                             (Object.keys(currentCamPermissions).length === 0 ||
                              (currentCamPermissions[0] && currentCamPermissions[0].length === 0));


    // If restricted, set a flag for CommonLayout to check
    if (isRestrictedCountry || hasNoPermissions) {
      sessionStorage.setItem('isAccessRestricted', 'true');
    } else {
      // Clear the restriction flag when access is allowed
      sessionStorage.removeItem('isAccessRestricted');
    }

    // If restricted, show access denied page (without navbar - CommonLayout handles it)
    if (isRestrictedCountry || hasNoPermissions) {
      return (
        <div style={{
          width: '100%',
          height: '100%',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '1rem',
          margin: 0,
          overflow: 'hidden',
          boxSizing: 'border-box'
        }}>
          <div style={{
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            padding: '2rem',
            maxWidth: '500px',
            width: '90%',
            maxHeight: '80vh',
            textAlign: 'center',
            border: '1px solid #e1e5e9',
            overflow: 'auto',
            boxSizing: 'border-box'
          }}>
              <div style={{
                width: '60px',
                height: '60px',
                backgroundColor: theme.palette.primary.main,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem auto'
              }}>
                <SecurityIcon style={{ fontSize: '2rem', color: 'white' }} />
              </div>

              <h1 style={{
                fontSize: '1.5rem',
                fontWeight: '600',
                color: '#333333',
                marginBottom: '1rem',
                lineHeight: '1.3',
                fontFamily: theme.typography.fontFamily
              }}>
                Access Denied
              </h1>

              <p style={{
                fontSize: '1rem',
                color: '#666666',
                marginBottom: '1.5rem',
                lineHeight: '1.5',
                fontFamily: theme.typography.fontFamily
              }}>
                You are not authorized to access the CAM
              </p>

              <div style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '6px',
                padding: '1.25rem',
                marginBottom: '0',
                border: '1px solid #e9ecef'
              }}>
                <h3 style={{
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#333333',
                  marginBottom: '0.5rem',
                  fontFamily: theme.typography.fontFamily
                }}>
                  Need Help?
                </h3>
                <p style={{
                  fontSize: '0.9rem',
                  color: '#666666',
                  marginBottom: '1rem',
                  lineHeight: '1.4',
                  fontFamily: theme.typography.fontFamily
                }}>
                  If you believe this is an error or require access, please contact support through the service request portal.
                </p>

                <a
                  href="https://automation.accenture.com/resources/support-requests/user-guide-to-raise-a-service-request"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    padding: '12px 20px',
                    borderRadius: '6px',
                    textDecoration: 'none',
                    fontWeight: '500',
                    fontSize: '0.9rem',
                    fontFamily: theme.typography.fontFamily,
                    transition: 'background-color 0.2s ease',
                    border: 'none',
                    cursor: 'pointer'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = theme.palette.primary.dark}
                  onMouseOut={(e) => e.target.style.backgroundColor = theme.palette.primary.main}
                >
                  Submit Service Request
                </a>
            </div>
          </div>
        </div>
      );
    }

    // Otherwise, render the normal component
    return <WrappedComponent {...props} />;
  };

  const mapStateToProps = state => ({
    userDetails: state.auth.userDetails,
    camPermissions: state.auth.camPermissions,
  });

  return connect(mapStateToProps)(CountryRestrictedComponent);
};

export default withCountryRestriction;